import { FC } from 'react';
import { useSelector } from 'react-redux';
import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useShowSearchMetaTooltip } from 'shared/hooks';
import { selectRoomTypeFilter } from 'shared/selectors/filters';
import { FILTER_KEY } from './constants';
import { useRoomTypeChangeHandler } from './hooks';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const RoomTypeContainer: FC = () => {
  const { label, options, value } = useSelector(selectRoomTypeFilter);

  const onChange = useRoomTypeChangeHandler();

  const dropdownState = useDropdown(FILTER_KEY);

  const showSearchMetaTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      {...dropdownState}
      showTooltip={showSearchMetaTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownSelect multiple options={options} value={value} onChange={onChange} />}
    />
  );
};
